<template>
  <div class='oversea'>
    <div><img src="/static/images/activty/importantupdate/app_update/app_update_01.jpg"></div>
    <div><img src="/static/images/activty/importantupdate/app_update/app_update_02.jpg"></div>
    <div><img src="/static/images/activty/importantupdate/app_update/app_update_03.jpg"></div>
    <div><img src="/static/images/activty/importantupdate/app_update/app_update_04.jpg"></div>
    <div><img src="/static/images/activty/importantupdate/app_update/app_update_05.jpg"></div>
    <div><img src="/static/images/activty/importantupdate/app_update/app_update_06.jpg"></div>
    <div><img src="/static/images/activty/importantupdate/app_update/app_update_07.jpg"></div>
    <div><img src="/static/images/activty/importantupdate/app_update/app_update_08.jpg"></div>
    <div><img src="/static/images/activty/importantupdate/app_update/app_update_09.jpg"></div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  data() {
    return {}
  },
  watch: {},
  mounted() {},
  created() {
    this.$store.commit('SET_HEADER_TITLE', this.$t('title.importantUpdate'));
  },
  methods: {
  },
}

</script>
<style scoped>
.oversea img {
  width: 100%;
  display: block;
  overflow: hidden;
}

.oversea>div {
  position: relative;
}

.oversea>div>span {
  position: absolute;
  width: 45vw;
  height: 7vw;
  bottom: 3vw;
  right: 20vw;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/appimportantupdate.vue